<script>
export default {
  name: 'Plaque',

  props: {
    text: {
      type: String,
      default: ''
    }
  },

  computed: {
    normalizedText() {
      return typeof this.text === 'string' ? this.text.trim() : '';
    },

    isPlaceholder() {
      return !this.normalizedText;
    },

    isLongText() {
      return this.normalizedText.length > 80;
    },

    displayText() {
      return this.normalizedText || 'Dedication message';
    }
  }
};
</script>

<template>
  <div class="plaque relative w-full overflow-hidden rounded-xl box-border">
    <img src="https://media.double.giving/images/purple-plaque.jpg" alt="Plaque" class="plaque-image block w-full object-contain" />
    <div class="plaque-content absolute top-0 right-0 bottom-0 left-0 flex items-center justify-center pointer-events-none">
      <p class="plaque-text text-center font-bold" :class="{ 'plaque-text--placeholder': isPlaceholder, 'plaque-text--long': isLongText }">
        {{ displayText }}
      </p>
    </div>
  </div>
</template>
